import React from 'react';
import {maskAddressDetail} from "../../../../utils/format";

interface JobInfoSectionProps {
    data: any;
    showReRegister?: boolean;
    onReRegister?: () => void;
    maskAddress?: boolean;
}

const getStatusLabel = (status: string, matchFailed?: boolean): string => {
    // 내가 지원했으나 다른 코디가 매칭된 경우 (백엔드 계산값)
    if (matchFailed) return '매칭실패';
    switch (status) {
        case 'RECRUITING': return '매칭대기';
        case 'MATCHED': return '예약완료';
        case 'ONGOING': return '진행중';
        case 'COMPLETED': return '완료';
        case 'CANCELLED': return '취소';
        default: return status || '';
    }
};

const getStatusClass = (status: string, matchFailed?: boolean): string => {
    if (matchFailed) return 'status status-cancel';          // 빨강
    switch (status) {
        case 'RECRUITING': return 'status status-waiting';    // 파랑
        case 'MATCHED': return 'status status-matched';       // 초록
        case 'ONGOING': return 'status status-ongoing';       // 초록
        case 'COMPLETED': return 'status status-completed';   // 회색
        case 'CANCELLED': return 'status status-cancel';      // 빨강
        default: return 'status';
    }
};

export const JobInfoSection: React.FC<JobInfoSectionProps> = ({ data, showReRegister, onReRegister, maskAddress = false }) => (
    <section className="bg-gray">
        <div className="inner-box">
            <div className="col-info">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <p className="number">
                        공고번호 : {data.jobPostingCode}
                        <span className={getStatusClass(data.status, data.matchFailed)} style={{ marginLeft: '8px' }}>{getStatusLabel(data.status, data.matchFailed)}</span>
                    </p>
                    {showReRegister && (
                        <button
                            type="button"
                            className="edit-btn"
                            onClick={onReRegister}
                        >
                            공고 재등록
                        </button>
                    )}
                </div>
                <p className="location">{data.address}</p>
                <p className="address">{maskAddress ? maskAddressDetail(data.addressDetail) : data.addressDetail}</p>
                <div className="tag-list">
                    <span className="tag color">{data.categoryName}</span>
                    <span className="tag">{data.workTypeName}</span>
                </div>
                <div className="round-box mt10">
                    <div className="round-body">
                        <div className="info-row">
                            <span className="label">급여</span>
                            <span className="cont">
                {data.workTypeName === '시간제' ? '시급' : '일급'} {data.dailyPay?.toLocaleString()}원
                                {data.negotiable && <span></span>}
              </span>
                        </div>
                        <div className="info-row">
                            <span className="label">간병일자</span>
                            <span className="cont">
                {data.careStartDate} ~ {data.careEndDate} ({data.totalDays}일)
              </span>
                        </div>
                        {data.workTypeName === '시간제' && (
                            <div className="info-row">
                                <span className="label">돌봄시간</span>
                                <span className="cont">{data.workStartTime} ~ {data.workEndTime}</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    </section>
);
